import React from "react";
import "./index.css";

const MaintenancePage = ({configuration}) => {
    console.log('logo_dark = ', configuration)
    return (
        <div className="maintenance-container">
            <div className="maintenance-box">
                <div>
                    <img src={configuration?.logo_white} alt="" style={{
                        width: 200,
                        objectFit: 'contain'
                    }}/>
                </div>
                <div className="emojis">🎰💎🔥</div>
                <h1>Bakımdayız! Masalar Hazırlanıyor 🛠️</h1>
                <p>
                    Sistemimizi sizin için yeniden ayarlıyoruz... ♠️♥️<br/>
                    Kartlar karılıyor, jackpot hazırlanıyor! 💰🎲<br/>
                    Çok yakında daha hızlı, daha şans dolu bir deneyimle buradayız! 🚀<br/><br/>
                    🍀 Şansını kaçırma... Az sonra tekrar görüşmek üzere!
                </p>
            </div>
        </div>
    );
};

export default MaintenancePage;
